// openEHR AM model — BMM package org.openehr.am.aom2.definitions
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import * as openehr_base from "../../base/mod.ts";

/**
 * Definitions relating to the internal code system of archetypes.
 */
export class ADL_CODE_DEFINITIONS {
  /**
   * True if \`_a_child_code_\` conforms to \`_a_parent_code_\` in the sense of specialisation, i.e. is \`_a_child_code_\` the same as or more specialised than \`_a_parent_code_\`?
   * @param a_child_code - Parameter
   * @param a_parent_code - Parameter
   * @returns Result value
   */
  codes_conformant(
    a_child_code: openehr_base.String,
    a_parent_code: openehr_base.String,
  ): openehr_base.Boolean {
    // TODO: Implement codes_conformant behavior
    // This will be covered in Phase 3 (see ROADMAP.md)
    throw new Error("Method codes_conformant not yet implemented.");
  }

  /**
   * True if \`_a_code_\` is any kind of ADL archetype local code.
   * @param a_code - Parameter
   * @returns Result value
   */
  is_adl_code(a_code: openehr_base.String): openehr_base.Boolean {
    // TODO: Implement is_adl_code behavior
    // This will be covered in Phase 3 (see ROADMAP.md)
    throw new Error("Method is_adl_code not yet implemented.");
  }

  /**
   * True if \`_a_code_\` is an 'id' code.
   * @param a_code - Parameter
   * @returns Result value
   */
  is_id_code(a_code: openehr_base.String): openehr_base.Boolean {
    // TODO: Implement is_id_code behavior
    // This will be covered in Phase 3 (see ROADMAP.md)
    throw new Error("Method is_id_code not yet implemented.");
  }

  /**
   * True if \`_a_code_\` is an 'at' code, i.e. a code representing a single terminology item.
   * @param a_code - Parameter
   * @returns Result value
   */
  is_value_code(a_code: openehr_base.String): openehr_base.Boolean {
    // TODO: Implement is_value_code behavior
    // This will be covered in Phase 3 (see ROADMAP.md)
    throw new Error("Method is_value_code not yet implemented.");
  }

  /**
   * True if \`_a_code_\` is an 'ac' code, i.e. a code referring to a terminology value set.
   * @param a_code - Parameter
   * @returns Result value
   */
  is_value_set_code(a_code: openehr_base.String): openehr_base.Boolean {
    // TODO: Implement is_value_set_code behavior
    // This will be covered in Phase 3 (see ROADMAP.md)
    throw new Error("Method is_value_set_code not yet implemented.");
  }

  /**
   * A code has been specialised if there is a non-zero code index anywhere above the last index e.g.
   *
   * * \`at0.0.1\` -> False
   * * \`at1.0.1\` -> True
   * @param a_code - Parameter
   * @returns Result value
   */
  is_redefined_code(a_code: openehr_base.String): openehr_base.Boolean {
    // TODO: Implement is_redefined_code behavior
    // This will be covered in Phase 3 (see ROADMAP.md)
    throw new Error("Method is_redefined_code not yet implemented.");
  }

  /**
   * Is \`_a_code_\` valid at level \`_a_level_\` or less, i.e. if we remove its trailing specialised part corresponding to specialisation below \`_a_level_\`, and then any trailing '.0' pieces, do we end up with a valid code? If so it means that the code corresponds to a real node from \`_a_level_\` or higher.
   * @param a-code - Parameter
   * @param a_level - Parameter
   * @returns Result value
   */
  code_exists_at_level(
    a_code: openehr_base.String,
    a_level: openehr_base.Integer,
  ): openehr_base.Boolean {
    // TODO: Implement code_exists_at_level behavior
    // This will be covered in Phase 3 (see ROADMAP.md)
    throw new Error("Method code_exists_at_level not yet implemented.");
  }
}
